import { projectSelectors } from 'features/BillOfMaterials/store/selectors/projectSelectors'
import { BomItemPointer } from 'model/Project/BomItemPointer'
import { useEffect, useRef } from 'react'
import { useAppSelector } from 'store/configureStore'
import { ModelController } from './manager/ModelController'
import { ModelContextMenu } from './tools/ModelContextMenu'
import { ViewerTools } from './tools/ViewerTools'

type Props = {
  bomItemPointer: BomItemPointer
  show3DOr2D: '3D' | '2D'
  modelController: ModelController
  onReload: () => void
}

export const BomItemModelViewer = (props: Props) => {
  const fileName = useAppSelector(
    props.show3DOr2D === '3D'
      ? projectSelectors.bomItem3DPathSelector(props.bomItemPointer)
      : projectSelectors.bomItem2DPathSelector(props.bomItemPointer),
  )

  const modelElementRef = useRef<HTMLDivElement>(undefined)

  useEffect(() => {
    if (!fileName) return

    if (modelElementRef.current) {
      props.modelController.init(modelElementRef.current)

      props.show3DOr2D === '3D'
        ? props.modelController.load3DModel(props.bomItemPointer, fileName)
        : props.modelController.load2DModel(props.bomItemPointer, fileName)
    }
  }, [fileName, props.bomItemPointer, props.modelController, props.show3DOr2D])

  if (!fileName) {
    return null
  }

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
      }}
    >
      <ViewerTools
        bomItemPointer={props.bomItemPointer}
        show3DOr2D={props.show3DOr2D}
        viewController={props.modelController}
      />
      <div
        id={`model-canvas-${props.show3DOr2D}`}
        ref={modelElementRef}
        style={{
          width: '100%',
          height: 'calc(100% - 1rem)',
          marginTop: '1rem',
        }}
      />
      <ModelContextMenu
        modelViewer={props.modelController}
        bomItemPointer={props.bomItemPointer}
        onReload={props.onReload}
      />
    </div>
  )
}
